'use client';
import { useRouter } from 'next/navigation';
import { DialogTrigger } from '@/components/dialog';
import { DialogWrapper } from '@/components/dialog/DialogWrapper';
import LeavingDialog from '@/components/dialog/LeavingDialog';
import { useState } from 'react';
import PostErrorModal from '@/components/dialog/PostErrorModal';
import { setCookies } from '@/actions/auth';
import { APP_STATUS } from '@/constants/appStatus';
import { Result } from '../../../types/result';

type PaginationProps = {
  next: string | null;
  prev: string | null;
  disabled?: boolean;
  updateProfile?: () => Promise<Result<any>>;
  children: React.ReactNode;
};

export default function RegisterLayout({
  next,
  prev,
  disabled = false,
  updateProfile,
  children
}: PaginationProps) {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(false);

  const onClickBack = (e: unknown) => {
    router.push(`register?q=${prev}`);
  };
  const onClickNext = async () => {
    try {
      if (updateProfile) {
        const updateUserProfileResult = await updateProfile();
        if (!updateUserProfileResult.isSuccess) {
          setIsVisible(true);
          return;
        }
      }

      // TODO: cookiesの値は登録画面の数だけ新設する
      await setCookies({
        appStatus: APP_STATUS.userInformationRegistered
      });

      // TODO: 登録動線の最後に以下のFirebaseイベント発火を行う
      // Firebaseイベント発火
      // await sendEvent(EVENTS.userCareerRegistered);
      // router.push('/value');

      router.push(`register?q=${next}`);
    } catch (error) {
      setIsVisible(true);
    }
  };
  const prevBtnStyle =
    'mr-auto rounded-[33px] border-[2px] border-solid border-[#555] px-[32px] py-[16px] font-semibold text-[#555] hover:cursor-pointer hover:opacity-70 md:mx-auto md:px-[72px]';
  return (
    <>
      {children}
      <div className="fixed bottom-0 left-0 flex w-full bg-neutral-100 p-[20px] opacity-80 md:absolute md:bottom-[-100px] md:justify-between md:p-0">
        {prev ? (
          <button name="prev" onClick={onClickBack} className={prevBtnStyle}>
            戻る
          </button>
        ) : (
          <DialogWrapper>
            <DialogTrigger asChild>
              <button className={prevBtnStyle}>戻る</button>
            </DialogTrigger>
            <LeavingDialog />
          </DialogWrapper>
        )}
        <button
          disabled={!next || disabled}
          name="next"
          onClick={onClickNext}
          className={`ml-auto rounded-[33px] border-[2px] border-solid px-[32px] py-[16px] font-semibold md:mx-auto md:px-[72px] ${
            !disabled
              ? 'border-primary text-primary-500 hover:cursor-pointer hover:opacity-70'
              : 'border-[#ddd] text-[#ddd]'
          }`}
        >
          次へ
        </button>
      </div>
      {isVisible ? (
        <PostErrorModal
          title="経歴登録処理"
          closeModal={() => setIsVisible(false)}
        />
      ) : null}
    </>
  );
}
